import { removeWhiteSpaceAndHyphenChars } from "../../../Model/helpers";

export class DashboardColour {
    static primary: string = '#233F96'; // darkBlue
    static primaryLight: string = '#4f65ab'; // light blue
    static secondary: string = '#79C79C'; // green
    static secondaryLight: string = '#93d2af'; // light green thing
    static grey: string = '#CCCCCC';
    static white: string = '#FFFFFF';

    static availablePoints: string = '#233F96';
    static gapAnalysisGap: string = '#D64556';
    static sdLimitationRedSteppedArea = "#FF9E95";
    static sdLimitationGreenSteppedArea = "#A2FFA0";
    static sdLimitationExceedingGap: string = '#FF4F4B'; //light-red
    static sdLimitationLessThanGap: string = '#FFA500'; //orange
    static sdLimitationActualSpend: string = '#29b6f6'; //light-blue
    static actualAchievedPointsColor: string = '#79C79C';

    static scenarioAchievedPointsColor: string = '#34b233';
    static ownTargetAchievedPointsColor: string = '#006fa3';
    static scorecardComparatorPointsColor: string = '#B9995D';

    static scorecardComparatorRowPointsColor: string = '#F0E3D1';
    static scorecardScenarioColour: string = '#34b2331a';
    static scorecardOwnTargetColour: string = '#006fa326';

    //BEE Recognition level Chart 
    static notAchievedlevelgrey: string = '#D6DBE0';

    //Employee HeadCount Chart Colours

    //option race
    static AfricanMale = '#293F6B';
    static AfricanFemale = '#607BB2';
    static IndianMale = '#ad8e09';
    static IndianFemale = '#FFD20D';
    static ColouredMale = '#5C6A24';
    static ColouredFemale = '#9BB43E';
    static WhiteMale = '#9D6F8A';
    static WhiteFemale = '#D597BC';
    static NonRSAMale = '#6A6A6A';
    static NonRSAFemale = '#B4B4B4';

    static ancillarytrainingexpenses = '#293F6B';
    static formalexternalsd = '#607BB2';
    static generalexpenseslimited = '#ad8e09';
    static generalexpensesnotlimited = '#FFD20D';
    static hebursaries = '#5C6A24';
    static internalsd = '#9BB43E';
    static lai = '#9D6F8A';
    static relatedstaffsalaries = '#6A6A6A';
    static informalexternalsd = '#B4B4B4';

    static High = '#607BB2';
    static Low = '#FF7133';
    static Average = '#CCCCCC';
    static Median = '#FFC300';

    static colour0: string = "#D2691E";
    static colour1: string = '#1c2951';
    static colour2: string = '#C7489D';
    static colour3: string = "#A2FFA0";
    static colour4: string = "#FF9E95";
    static colour5: string = 'E10000'; //red
    static colour6: string = '2DC300'; //green
    static colour7: string = '#830459';
    static colour8: string = '#34b233';
    static colour9: string = '#006fa3';
    static colour10: string = '#B9995D';
    static colour11: string = '#4B0082';
    static colour12: string = '#B0C4DE';
    static colour13: string = "#7FFFD4";

    static red: string = 'E10000';

    static pieChartColourCollection = ['#4270c1', '#e97c30', '#9b460c', '#fbbd00', '#5a99d3', '#6eab46', '#244276', '#997300', '#636363', '#006fa3', '#a3a3a3'];


    findByName(name: string) {
        name = removeWhiteSpaceAndHyphenChars(name?.toLowerCase()?.trim() || '');
        switch (name) {
            case 'africanmale':
                return DashboardColour.AfricanMale;
            case 'africanfemale':
                return DashboardColour.AfricanFemale;
            case 'indianmale':
                return DashboardColour.IndianMale;
            case 'indianfemale':
                return DashboardColour.IndianFemale;
            case 'colouredmale':
                return DashboardColour.ColouredMale;
            case 'colouredfemale':
                return DashboardColour.ColouredFemale;
            case 'whitemale':
                return DashboardColour.WhiteMale;
            case 'whitefemale':
                return DashboardColour.WhiteFemale;
            case 'nonrsamale':
            case 'nonsouthafricanmale':
                return DashboardColour.NonRSAMale;
            case 'nonrsafemale':
            case 'nonsouthafricanfemale':
                return DashboardColour.NonRSAFemale;
            default:
                return DashboardColour.grey;

        }
    }

    findBySkillsDevCategoryName(name: string) {
        const localName = removeWhiteSpaceAndHyphenChars(name?.toLowerCase()?.trim() || '');
        switch (localName) {
            case 'ancillarytrainingexpenses':
                return DashboardColour.ancillarytrainingexpenses;
            case 'formalexternalskillsdevelopment':
                return DashboardColour.formalexternalsd;
            case 'informalexternalskillsdevelopment':
                return DashboardColour.informalexternalsd;
            case 'internalskillsdevelopment':
                return DashboardColour.internalsd;
            case "lais":
                return DashboardColour.lai;
            case 'relatedstaffsalarieslimited':
                return DashboardColour.NonRSAFemale;
            case 'generalexpenseslimited':
                return DashboardColour.generalexpenseslimited;
            case 'highereducationbursaries':
                return DashboardColour.hebursaries;
            case 'generalexpensesnotlimited':
                return DashboardColour.generalexpensesnotlimited;
            default:
                return DashboardColour.grey;
        }
    }

    findByGender(name: string) {
        name = removeWhiteSpaceAndHyphenChars(name?.toLowerCase()?.trim() || '');
        switch (name) {
            case 'votingrightsheldbyblackpeople':
                return DashboardColour.colour0;
            case 'votingrightsheldbynonblackpeople':
                return DashboardColour.colour1;
            default:
                return DashboardColour.grey;

        }
    }

    findBySortOrder(idx: number) {
        idx = Math.round(idx);
        if (idx >= 13 || idx < 0) {
            return DashboardColour.colour13;
        }

        return (DashboardColour as any)["colour" + idx];
    }
}